import { Navigate, Route, Routes } from 'react-router-dom';

import { RequireAuth } from './auth/RequireAuth';
import { CabinetPage } from './features/cabinet/CabinetPage';
import { GroupPage } from './features/group/GroupPage';
import { ProgramsPage } from './features/programs/ProgramsPage';
import { ReportsPage } from './features/reports/ReportsPage';
import { ScannerPage } from './features/scanner/ScannerPage';
import { SchedulePage } from './features/schedule/SchedulePage';
import { LoginPage } from './pages/LoginPage';
import { PendingApprovalPage } from './pages/PendingApprovalPage';

/** Маршруты панели представителя предприятия (ТЗ FR-MGR-01…06, FR-B2B-04). */
export function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/pending" element={<PendingApprovalPage />} />
      <Route
        path="/scanner"
        element={
          <RequireAuth>
            <ScannerPage />
          </RequireAuth>
        }
      />
      <Route
        path="/schedule"
        element={
          <RequireAuth>
            <SchedulePage />
          </RequireAuth>
        }
      />
      <Route
        path="/group"
        element={
          <RequireAuth>
            <GroupPage />
          </RequireAuth>
        }
      />
      <Route
        path="/reports"
        element={
          <RequireAuth>
            <ReportsPage />
          </RequireAuth>
        }
      />
      <Route
        path="/programs"
        element={
          <RequireAuth>
            <ProgramsPage />
          </RequireAuth>
        }
      />
      <Route
        path="/cabinet"
        element={
          <RequireAuth>
            <CabinetPage />
          </RequireAuth>
        }
      />
      <Route path="*" element={<Navigate to="/scanner" replace />} />
    </Routes>
  );
}
